<template>
	<div class="settings">

		<div>
			<button @click="e => openMenu( e, button )" class="settings__button" v-for="button in buttons">
				<post-smtp-img :show-point="!!failed_notifications.length" :src="button.icon"></post-smtp-img>
			</button>
		</div>

		<post-smtp-settings-menu
			:style="showHideSettingBar"
			:menus="[
				{
					title: i18n[0],
					icon: 'menu-profile',
					url: admin_url + '?page=postman%2Fconfiguration#account_config'
				},
				{
					title: i18n[1],
					icon: 'menu-fallback',
					url: admin_url + '?page=postman%2Fconfiguration#fallback'
				},
				{
					title: i18n[2],
					icon: 'menu-message',
					url: admin_url + '?page=postman%2Fconfiguration#message_config'
				},
				{
					title: i18n[3],
					icon: 'menu-logging',
					url: admin_url + '?page=postman%2Fconfiguration#logging_config'
				},
				{
					title: i18n[4],
					icon: 'menu-settings',
					url: admin_url + '?page=postman%2Fconfiguration#advanced_options_config'
				},
				{
					title: i18n[5],
					icon: 'menu-bell',
					url: admin_url + '?page=postman%2Fconfiguration#notifications'
				},
			]"
		></post-smtp-settings-menu>

		<post-smtp-notification-bar
			:style="showHideNotificationBar"
			:notifications="failed_notifications"
		></post-smtp-notification-bar>
	</div>
</template>

<script>

export default {
	name: 'PostSMTPSettings',

	props: {
		buttons: {
			type: Array,
			default: () => [],
		},
	},

	data: ( vm ) => ( {
		plugin_dir_url : vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
    i18n: postSmtpNewDashboard.i18n.settings,
		setting        : false,
		notification   : false,

		failed_notifications: [],
	} ),

	watch: {
	},

	computed: {
		showHideNotificationBar() {
			var display;
			if ( this.notification ) {
				display = 'block';
			} else {
				display = 'none';
			}

			return {
				display: display,
			};
		},
		showHideSettingBar() {
			var display;
			if ( this.setting ) {
				display = 'block';
			} else {
				display = 'none';
			}

			return {
				display: display,
			};
		},
	},

	methods: {
		openMenu( e, button ) {
			e.preventDefault();


			if ( 'setting' === button.action ) {
				this.notification = false;
				this.setting      = ! this.setting;
			}

			if ( 'bell' === button.action ) {
				this.setting      = false;
				this.notification = ! this.notification;
			}
		},

		getFailedNotifications() {
			axios.get( 'get-failed-logs' )
				.then( response => {
					this.failed_notifications = response.data.logs;
					this.failed_notifications = Object.values( this.failed_notifications );
				} );
		}
	},

	mounted() {
		this.getFailedNotifications();

		document.body.addEventListener( 'click', ( e ) => {
			if ( ! e.target.closest( '.settings' ) ) {
				this.setting      = false;
				this.notification = false;
			}
		} );
	}
}
</script>

<style scoped>
.settings__button {
	background: none;
	border: none;
	cursor: pointer;

	padding-right: 16px;
}

.settings__button:last-child {
	padding-right: 0;
}
</style>